import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { Button } from "../../components/ui/button";
import { FieldError } from "../../components/common/States";
import { api, formatApiError, linkParam } from "../../lib/api";
import { AuthCard } from "./Login";
import { Field } from "./Register";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(null);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { setError("Email invalide"); return; }
    setLoading(true); setError("");
    try { const { data } = await api.post("/auth/forgot-password", { email }); setDone(data.message); }
    catch (err) { setError(formatApiError(err)); } finally { setLoading(false); }
  };
  return (
    <AuthCard title="Mot de passe oublié" subtitle="Recevez un lien de réinitialisation valable 1 heure."
      footer={<Link to="/connexion" className="font-medium text-blue-600" data-testid="forgot-back-login">Retour à la connexion</Link>}>
      {done ? (
        <p className="flex items-start gap-2 text-sm text-slate-700" data-testid="forgot-success"><CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" />{done}</p>
      ) : (
        <form onSubmit={submit} className="space-y-4" noValidate>
          <Field id="forgot-email" label="Email du compte" type="email" value={email} onChange={(e) => setEmail(e.target.value)} error={error} />
          <Button type="submit" className="h-11 w-full rounded-full" disabled={loading} data-testid="forgot-submit-button">{loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Envoyer le lien</Button>
        </form>
      )}
    </AuthCard>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [f, setF] = useState({ password: "", confirm: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const token = linkParam(params);
  const submit = async (e) => {
    e.preventDefault();
    const errs = {};
    if (f.password.length < 8) errs.password = "8 caractères minimum";
    if (f.password !== f.confirm) errs.confirm = "Les mots de passe ne correspondent pas";
    setErrors(errs);
    if (Object.keys(errs).length) return;
    setLoading(true);
    try { await api.post("/auth/reset-password", { token, password: f.password }); navigate("/connexion?reset=1", { replace: true }); }
    catch (err) { setErrors({ form: formatApiError(err) }); } finally { setLoading(false); }
  };
  return (
    <AuthCard title="Nouveau mot de passe" footer={<Link to="/mot-de-passe-oublie" className="font-medium text-blue-600" data-testid="reset-new-request">Faire une nouvelle demande</Link>}>
      {!token ? <p className="text-sm text-rose-600" data-testid="reset-missing-token">Lien incomplet. Utilisez le lien reçu par email.</p> : (
        <form onSubmit={submit} className="space-y-4" noValidate>
          <Field id="reset-password" label="Nouveau mot de passe" type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} error={errors.password} />
          <Field id="reset-password-confirm" label="Confirmer" type="password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} error={errors.confirm} />
          <FieldError>{errors.form && <span data-testid="reset-error">{errors.form}</span>}</FieldError>
          <Button type="submit" className="h-11 w-full rounded-full" disabled={loading} data-testid="reset-submit-button">{loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Enregistrer</Button>
        </form>
      )}
    </AuthCard>
  );
}
